import { render, staticRenderFns } from "./Ekwateur.vue?vue&type=template&id=2d8f403e&scoped=true"
import script from "./Ekwateur.vue?vue&type=script&lang=js"
export * from "./Ekwateur.vue?vue&type=script&lang=js"
import style0 from "./Ekwateur.vue?vue&type=style&index=0&id=2d8f403e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f403e",
  null
  
)

export default component.exports